import React, { useMemo, useState } from "react";
import { Filter, Header, ImportOutboundModal } from "./component";
import { DataTable, Excel } from "CommonComponent";

const Import = () => {

    const [showModal, setShowModal] = useState(false);

  const handleOpen = () => setShowModal(true);
  const handleClose = () => setShowModal(false);
  // Define columns for DataTable
  const columns = useMemo(
    () => [
      {
        id: "period",
        header: "Period",
        accessor: (row) => row.period,
        sortable: true,
        searchable: true,
      },
      {
        id: "media_type",
        header: "Media Type",
        accessor: (row) => row.media_type,
        sortable: true,
        searchable: true,
      },
      {
        id: "date",
        header: "Date",
        accessor: (row) => row.date,
        sortable: true,
        searchable: false,
      },
      {
        id: "direction",
        header: "Direction",
        accessor: (row) => row.direction,
        sortable: true,
        searchable: false,
      },
      {
        id: "queue_name",
        header: "Queue Name",
        accessor: (row) => row.queue_name,
        sortable: true,
        searchable: true,
      },
      {
        id: "abandoned",
        header: "Abandoned",
        accessor: (row) => row.abandoned,
        sortable: true,
        searchable: false,
      },
      {
        id: "total_wait",
        header: "Total Wait",
        accessor: (row) => row.total_wait,
        sortable: true,
        searchable: false,
      },
      {
        id: "total_talk",
        header: "Total Talk",
        accessor: (row) => row.total_talk,
        sortable: true,
        searchable: false,
      },
      {
        id: "total_hold",
        header: "Total Hold",
        accessor: (row) => row.total_hold,
        sortable: true,
        searchable: false,
      },
      {
        id: "total_acw",
        header: "Total ACW",
        accessor: (row) => row.total_acw,
        sortable: true,
        searchable: false,
      },
    ],
    []
  );

  // Dummy data for DataTable
  const data = [
    {
      id: 1,
      period: "2025-10",
      media_type: "Voice",
      date: "2025-10-20",
      direction: "Inbound",
      queue_name: "Support Queue",
      abandoned: 12,
      total_wait: "00:03:12",
      total_talk: "00:15:40",
      total_hold: "00:01:20",
      total_acw: "00:02:10",
    },
    {
      id: 2,
      period: "2025-10",
      media_type: "Chat",
      date: "2025-10-19",
      direction: "Outbound",
      queue_name: "Sales Queue",
      abandoned: 5,
      total_wait: "00:01:45",
      total_talk: "00:10:30",
      total_hold: "00:00:50",
      total_acw: "00:01:05",
    },
    {
      id: 3,
      period: "2025-09",
      media_type: "Voice",
      date: "2025-09-30",
      direction: "Inbound",
      queue_name: "Billing Queue",
      abandoned: 8,
      total_wait: "00:02:30",
      total_talk: "00:12:15",
      total_hold: "00:00:40",
      total_acw: "00:01:30",
    },
  ];

  return (
    <div className="wrapper-div">
      <Header />
      <div className="d-flex align-items-center justify-content-end pb-4 px-4 gap-3">
        <button className="delete-btn">
          <img
            src="/assets/images/delete-icon-white.svg"
            alt=""
            className="me-2"
          />
          Delete
        </button>
        <Excel />
        <button className="c-b-btn"  onClick={handleOpen}>
          <img
            src="/assets/images/import-icon.svg"
            alt=""
            className="me-2"
          />
          Import
        </button>
      </div>
      <Filter />
      <DataTable
        columns={columns}
        data={data}
        serverSide={false}
        showSearch={false}
        className="table-container"
      />

      <ImportOutboundModal show={showModal} handleClose={handleClose} />
    </div>
  );
};

export default Import;
